"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOCALES = exports.LANGUAGES = void 0;
var LANGUAGES;

(function (LANGUAGES) {
  LANGUAGES["ca"] = "ca";
  LANGUAGES["cz"] = "cs";
  LANGUAGES["de"] = "de";
  LANGUAGES["en"] = "en";
  LANGUAGES["es"] = "es";
  LANGUAGES["eu"] = "eu";
  LANGUAGES["fr"] = "fr";
  LANGUAGES["gl"] = "gl";
  LANGUAGES["it"] = "it";
  LANGUAGES["ko"] = "ko";
  LANGUAGES["nl"] = "nl";
  LANGUAGES["pl"] = "pl";
  LANGUAGES["pt"] = "pt";
  LANGUAGES["ro"] = "ro";
})(LANGUAGES = exports.LANGUAGES || (exports.LANGUAGES = {}));

var LOCALES;

(function (LOCALES) {
  LOCALES[LOCALES["ca-ES"] = 0] = "ca-ES";
  LOCALES[LOCALES["cs-CZ"] = 1] = "cs-CZ";
  LOCALES[LOCALES["de-AT"] = 2] = "de-AT";
  LOCALES[LOCALES["de-CH"] = 3] = "de-CH";
  LOCALES[LOCALES["de-DE"] = 4] = "de-DE";
  LOCALES[LOCALES["en-AQ"] = 5] = "en-AQ";
  LOCALES[LOCALES["en-AT"] = 6] = "en-AT";
  LOCALES[LOCALES["en-CA"] = 7] = "en-CA";
  LOCALES[LOCALES["en-CH"] = 8] = "en-CH";
  LOCALES[LOCALES["en-CZ"] = 9] = "en-CZ";
  LOCALES[LOCALES["en-DE"] = 10] = "en-DE";
  LOCALES[LOCALES["en-ES"] = 11] = "en-ES";
  LOCALES[LOCALES["en-FR"] = 12] = "en-FR";
  LOCALES[LOCALES["en-GB"] = 13] = "en-GB";
  LOCALES[LOCALES["en-KR"] = 14] = "en-KR";
  LOCALES[LOCALES["en-NL"] = 15] = "en-NL";
  LOCALES[LOCALES["en-NZ"] = 16] = "en-NZ";
  LOCALES[LOCALES["en-PL"] = 17] = "en-PL";
  LOCALES[LOCALES["en-PT"] = 18] = "en-PT";
  LOCALES[LOCALES["en-RO"] = 19] = "en-RO";
  LOCALES[LOCALES["en-US"] = 20] = "en-US";
  LOCALES[LOCALES["en-ZA"] = 21] = "en-ZA";
  LOCALES[LOCALES["es-ES"] = 22] = "es-ES";
  LOCALES[LOCALES["eu-ES"] = 23] = "eu-ES";
  LOCALES[LOCALES["fr-CA"] = 24] = "fr-CA";
  LOCALES[LOCALES["fr-CH"] = 25] = "fr-CH";
  LOCALES[LOCALES["fr-FR"] = 26] = "fr-FR";
  LOCALES[LOCALES["gl-ES"] = 27] = "gl-ES";
  LOCALES[LOCALES["it-CH"] = 28] = "it-CH";
  LOCALES[LOCALES["ko-KR"] = 29] = "ko-KR";
  LOCALES[LOCALES["nl-NL"] = 30] = "nl-NL";
  LOCALES[LOCALES["pl-PL"] = 31] = "pl-PL";
  LOCALES[LOCALES["pt-PT"] = 32] = "pt-PT";
  LOCALES[LOCALES["ro-RO"] = 33] = "ro-RO";
})(LOCALES = exports.LOCALES || (exports.LOCALES = {}));